<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>

          <page-title :title="pageTitle" />

          <b-alert v-if="client && client.isOffline" show variant="info">
            This client is currently available offline.
          </b-alert>

          <div v-if="client && !client.isOffline && isCheckoutSupported === null">
            <b-alert show class="mb-3" variant="info">
              Checking to see if offline access is supported...
            </b-alert>            
          </div>

          <div v-if="client && !client.isOffline && isCheckoutSupported === false">
            <b-alert show class="mb-3" variant="warning">
              Sorry, offline access is not supported on your web browser. Try refreshing this page.
            </b-alert>            
          </div>

          <div v-if="client && !client.isOffline && isCheckoutSupported">
            <p>Do you want to check out {{ client.applicationUser.displayName }} for offline access?</p>
            <p>When a client is checked out for offline access, you can proctor the questionnaire without needing to be connected to the internet. Any data you
              enter while offline will be temporarily stored automatically on your device. When you once again have internet connectivity, you can check the
              client back in, which will automatically synchronize their data back to our system so you can download a mitigation report.
            </p>
            <b-button @click="checkOut" v-if="!client.isOffline" variant="primary">
              Check Out
            </b-button>
          </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import marked from 'marked';
import AuthMixin from '../../Mixins/AuthMixin.vue'

export default {
  name: "SubscriberClientCheckOut",
  props: ['id'],
  mixins: [AuthMixin],
  data() {
    return {
      client: null,
      isCheckoutSupported: null
    }
  },
  computed: {
    pageTitle: function () {
      if (!this.client)
        return 'Loading...';
      
      return 'Check Out ' + this.client.applicationUser.firstName + ' ' + this.client.applicationUser.lastName + ' For Offline Access';
    },
  },
  methods: {
    getIsCheckoutSupported: function () {
      navigator.serviceWorker.controller.postMessage({
        action: 'getIsCheckoutSupported'
      });
    },
    checkOut: function () {
      navigator.serviceWorker.controller.postMessage({
        action: 'checkOut',
        clientId: this.client.id,
        authToken: this.getAuthToken()
      });
    },
    load: function () {
      axios
        .get('/api/client/' + this.id + '?includes=applicationUser')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {
          console.log(error);
        });

        setTimeout(() => {
          if (!this.isCheckoutSupported)
            this.isCheckoutSupported = false;
        }, 2000);

        this.getIsCheckoutSupported();
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();

    navigator.serviceWorker.onmessage = msg => {
      if (msg.data.action == 'checkedOut') {
        this.load();

        this.$parent.showToast('That client is now checked out for offline access.', {
          title: 'Client Checked Out',
          variant: 'success',
          autoHideDelay: 5000
        });

        this.$router.push('/');
      }

      if (msg.data.action == 'gotIsCheckoutSupported') {
        this.isCheckoutSupported = true;
      }

    }
  }
};
</script>